import React from 'react';
import { useNavigate } from 'react-router-dom';
import ScenarioPlanner from '../components/ScenarioPlanner';
import '../styles/DashboardPage.scss';

const ScenarioPlanning = () => {
  const navigate = useNavigate();

  return (
    <div className="dp-container">
      <div className="dp-header">
        <button className="dp-back" onClick={() => navigate('/reports')}>← Back</button>
        <div className="dp-title">
          <h1>Scenario Planning</h1>
          <p>Calculate what it takes to reach a higher B-BBEE level</p>
        </div>
      </div>

      <div className="dp-body">
        <ScenarioPlanner />
      </div>
    </div>
  );
};

export default ScenarioPlanning;
